const route = [
  {
    path: '/gastos-reembolsables',
    name: 'gastosReembolsables',
    meta: { authRequired: true },
    component: () => import('./GastosReembolsables')
  },
  {
    path: '/gastos-reembolsablesRAC',
    name: 'gastosReembolsablesRAC',
    meta: { authRequired: true },
    component: () => import('./GastosReembolsables')
  },
  {
    path: '/gastos-details',
    name: 'gastosReembolsablesDetail',
    meta: { authRequired: true },
    component: () => import('./GastosReembolsablesDetail')
  },
  {
    path: '/gastos-documents/:id',
    name: 'documentosGastos',
    meta: { authRequired: true },
    component: () => import('./DocumentacionGastos')
  }
];

module.exports = {
  route
};
